import { useState, useEffect } from 'react'
import { ArtistDashboardData } from '@/lib/artistDashboardData'

interface DashboardData {
  profileViews: number
  activeChats: number
  mostSavedFlash: {
    id: string
    imageUrl: string
    saves: number
  } | null
  lastUpdated: Date
}

export function useArtistDashboardData(artistId: string, days: number = 7) {
  const [data, setData] = useState<DashboardData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const dashboardData = new ArtistDashboardData()
        const analytics = await dashboardData.getArtistAnalytics(artistId, days)
        setData(analytics)
      } catch (err) {
        setError(err as Error)
      } finally {
        setLoading(false)
      }
    }

    if (artistId) {
      fetchData()
    }
  }, [artistId, days])

  return { data, loading, error }
}
